// hotels-mock.ts — Static mock data for HotelsPage + HotelDetailPage.
// TODO(hotels-API-PR): Replace with /api/v1/hotels/search + /api/v1/hotels/:id

const IMG = (id: string, w = 800) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export interface HotelMock {
  id: string;
  name: string;
  area: string;
  distance: string;
  img: string;
  imgs: string[];
  rating: number;
  ratingLabel: string;
  reviews: number;
  price: number;
  oldPrice: number;
  perks: string[];
  tag: string;
  stars: number;
  freeCancellation: boolean;
  lat: number;
  lng: number;
}

export const HOTELS: HotelMock[] = [
  {
    id: 'h1', name: 'Bisma Eight', area: 'Ubud', distance: '1.2 km from center',
    img: IMG('1566073771259-6a8506099945'),
    imgs: [
      IMG('1566073771259-6a8506099945'),
      IMG('1571896349842-33c89424de2d'),
      IMG('1582719508461-905c673771fd'),
      IMG('1611892440504-42a792e24d32'),
      IMG('1564501049412-61c2a3083791'),
    ],
    rating: 9.2, ratingLabel: 'Exceptional', reviews: 2840,
    price: 184, oldPrice: 220,
    perks: ['Free breakfast', 'Pool', 'Spa', 'Wi-Fi'],
    tag: 'GUEST FAV', stars: 5, freeCancellation: true,
    lat: -8.5069, lng: 115.2625,
  },
  {
    id: 'h2', name: 'Potato Head Suites', area: 'Seminyak', distance: 'On the beach',
    img: IMG('1582719508461-905c673771fd'),
    imgs: [
      IMG('1582719508461-905c673771fd'),
      IMG('1564501049412-61c2a3083791'),
      IMG('1611892440504-42a792e24d32'),
      IMG('1566073771259-6a8506099945'),
      IMG('1571003123894-1f0594d2b5d9'),
    ],
    rating: 9.6, ratingLabel: 'Iconic', reviews: 1204,
    price: 298, oldPrice: 340,
    perks: ['Beachfront', 'Pool', 'Bar', 'Gym'],
    tag: 'EDITORS PICK', stars: 5, freeCancellation: true,
    lat: -8.6900, lng: 115.1571,
  },
  {
    id: 'h3', name: 'Hoshinoya Bali', area: 'Ubud', distance: '4.1 km from center',
    img: IMG('1571003123894-1f0594d2b5d9'),
    imgs: [
      IMG('1571003123894-1f0594d2b5d9'),
      IMG('1566073771259-6a8506099945'),
      IMG('1571896349842-33c89424de2d'),
      IMG('1582719508461-905c673771fd'),
      IMG('1611892440504-42a792e24d32'),
    ],
    rating: 9.4, ratingLabel: 'Exceptional', reviews: 891,
    price: 412, oldPrice: 480,
    perks: ['Private pool', 'Breakfast', 'Spa'],
    tag: 'LUXE', stars: 5, freeCancellation: false,
    lat: -8.4966, lng: 115.2711,
  },
  {
    id: 'h4', name: 'Katamama', area: 'Canggu', distance: '0.8 km from beach',
    img: IMG('1564501049412-61c2a3083791'),
    imgs: [
      IMG('1564501049412-61c2a3083791'),
      IMG('1582719508461-905c673771fd'),
      IMG('1566073771259-6a8506099945'),
      IMG('1571003123894-1f0594d2b5d9'),
      IMG('1611892440504-42a792e24d32'),
    ],
    rating: 8.9, ratingLabel: 'Wonderful', reviews: 612,
    price: 145, oldPrice: 180,
    perks: ['Surf access', 'Pool', 'Cafe'],
    tag: 'GEN-Z', stars: 4, freeCancellation: true,
    lat: -8.6478, lng: 115.1367,
  },
  {
    id: 'h5', name: 'The Layar', area: 'Seminyak', distance: '5 min from beach',
    img: IMG('1611892440504-42a792e24d32'),
    imgs: [
      IMG('1611892440504-42a792e24d32'),
      IMG('1582719508461-905c673771fd'),
      IMG('1564501049412-61c2a3083791'),
      IMG('1571003123894-1f0594d2b5d9'),
      IMG('1566073771259-6a8506099945'),
    ],
    rating: 9.1, ratingLabel: 'Superb', reviews: 445,
    price: 520, oldPrice: 640,
    perks: ['Private villa', 'Butler', 'Pool'],
    tag: 'ULTRA-LUX', stars: 5, freeCancellation: false,
    lat: -8.6888, lng: 115.1600,
  },
  {
    id: 'h6', name: 'Desa Seni', area: 'Canggu', distance: '10 min from beach',
    img: IMG('1571896349842-33c89424de2d'),
    imgs: [
      IMG('1571896349842-33c89424de2d'),
      IMG('1566073771259-6a8506099945'),
      IMG('1582719508461-905c673771fd'),
      IMG('1564501049412-61c2a3083791'),
      IMG('1611892440504-42a792e24d32'),
    ],
    rating: 8.7, ratingLabel: 'Excellent', reviews: 738,
    price: 210, oldPrice: 260,
    perks: ['Yoga', 'Organic food', 'Pool'],
    tag: 'WELLNESS', stars: 4, freeCancellation: true,
    lat: -8.6502, lng: 115.1320,
  },
  {
    id: 'h7', name: 'Alaya Resort Ubud', area: 'Ubud', distance: '0.5 km from center',
    img: IMG('1542718610-a1d656d1884c', 800),
    imgs: [
      IMG('1542718610-a1d656d1884c', 800),
      IMG('1571896349842-33c89424de2d'),
      IMG('1566073771259-6a8506099945'),
      IMG('1571003123894-1f0594d2b5d9'),
      IMG('1582719508461-905c673771fd'),
    ],
    rating: 9.0, ratingLabel: 'Superb', reviews: 1020,
    price: 175, oldPrice: 215,
    perks: ['Pool', 'Spa', 'Breakfast', 'Wi-Fi'],
    tag: 'BOUTIQUE', stars: 4, freeCancellation: true,
    lat: -8.5072, lng: 115.2640,
  },
  {
    id: 'h8', name: 'Finns Beach Club Villas', area: 'Canggu', distance: 'Beachfront',
    img: IMG('1502680390469-be75c86b636f', 800),
    imgs: [
      IMG('1502680390469-be75c86b636f', 800),
      IMG('1564501049412-61c2a3083791'),
      IMG('1611892440504-42a792e24d32'),
      IMG('1582719508461-905c673771fd'),
      IMG('1566073771259-6a8506099945'),
    ],
    rating: 8.8, ratingLabel: 'Excellent', reviews: 590,
    price: 320, oldPrice: 395,
    perks: ['Beachclub access', 'Pool', 'Bar', 'Surf'],
    tag: 'BEACH LIFE', stars: 4, freeCancellation: true,
    lat: -8.6481, lng: 115.1295,
  },
];

export interface AmenityItem {
  icon: string;
  label: string;
}

export const AMENITIES: AmenityItem[] = [
  { icon: 'wifi', label: 'Free Wi-Fi' },
  { icon: 'waves', label: 'Infinity pool' },
  { icon: 'sparkles', label: 'Daily spa' },
  { icon: 'coffee', label: 'Breakfast' },
  { icon: 'dumbbell', label: 'Fitness centre' },
  { icon: 'car', label: 'Airport transfer' },
  { icon: 'utensils', label: 'Restaurant' },
  { icon: 'cocktail', label: 'Rooftop bar' },
  { icon: 'clock', label: 'Late checkout' },
  { icon: 'wind', label: 'Air conditioning' },
  { icon: 'shield', label: 'Safe' },
  { icon: 'concierge-bell', label: 'Concierge' },
];

export interface RoomOption {
  name: string;
  size: string;
  view: string;
  beds: string;
  price: number;
  bestValue?: boolean;
  img: string;
  perks: string[];
}

export const ROOMS_PER_HOTEL: Record<string, RoomOption[]> = {
  default: [
    {
      name: 'Studio Suite',
      size: '48 m²',
      view: 'Garden view',
      beds: 'King bed',
      price: 298,
      img: IMG('1611892440504-42a792e24d32', 400),
      perks: ['Free cancel', 'No prepayment'],
    },
    {
      name: 'Pool Suite',
      size: '62 m²',
      view: 'Pool view',
      beds: 'King bed',
      price: 412,
      bestValue: true,
      img: IMG('1582719508461-905c673771fd', 400),
      perks: ['Free cancel', 'Breakfast incl.', 'Early check-in'],
    },
    {
      name: 'Beachfront Villa',
      size: '92 m²',
      view: 'Ocean view',
      beds: 'King + sofa bed',
      price: 698,
      img: IMG('1564501049412-61c2a3083791', 400),
      perks: ['Free cancel', 'Breakfast incl.', 'Butler service'],
    },
  ],
};

export const SAMPLE_REVIEWS = [
  {
    user: 'Maya J.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&q=80&auto=format&fit=crop',
    rating: 10,
    date: 'March 2026',
    text: 'Absolutely jaw-dropping. The pool at sunrise is something I will remember forever. Staff anticipated every need before we even had to ask.',
  },
  {
    user: 'Arjun K.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&q=80&auto=format&fit=crop',
    rating: 9,
    date: 'February 2026',
    text: 'Iconic for a reason. The curated record bar and Sunday sundowners are legendary. Rooms are enormous and the beach is just steps away.',
  },
  {
    user: 'Rhea W.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&q=80&auto=format&fit=crop',
    rating: 9,
    date: 'January 2026',
    text: 'Surpassed every expectation. The breakfast spread is extraordinary and the spa is worth every rupiah. Will absolutely return.',
  },
];
